import { render, staticRenderFns } from "./ticket-remark.vue?vue&type=template&id=fc8232e0&scoped=true&"
import script from "./ticket-remark.vue?vue&type=script&lang=js&"
export * from "./ticket-remark.vue?vue&type=script&lang=js&"
import style0 from "./ticket-remark.vue?vue&type=style&index=0&id=fc8232e0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc8232e0",
  null
  
)

export default component.exports